export default __webpack_public_path__ + "static/media/ILUSTRACIONES_07.ceba639e.png";